
export function GetServerUrl(v = 1) {
  return 'https://api.cnmgs.cn/v' + v + '/' // 生产环境
}

export function GetVideoUrl(v = 1) {
  return 'http://file.oid.plus'
}

//演示溯源信息
export function initDemoDatas(res) {
  const datas = res.meta;
  const defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

  //扫码次数
  datas.scan_count = datas.scan_count || 1;
  datas.scan_first_time = "2017-10-31 12:12"; //扫码时间
  datas.scan_first_address = "广东省深圳市"; //扫码地址

  //焦点图
  if (datas.focus) {
    datas.focus = JSON.parse(datas.focus);
  }

  //自定义栏目
  if (datas.ref) {
    datas.ref = JSON.parse(datas.ref);
  } else {
    if (defaultDatas.ref) {
      datas.ref = JSON.parse(defaultDatas.ref);
    }
  }

  //菜单信息
  if (datas.menu) {
    datas.menu = JSON.parse(datas.menu);
  }

  //批次信息
  if (datas.batch) {
    datas.batch = JSON.parse(datas.batch);
    if (datas.batch.qc) {
      datas.batch.qc = JSON.parse(datas.batch.qc);
    }
  }

  //背景音乐
  if (datas.music && datas.music_is_show == 1) {
    try {
      datas.music = JSON.parse(datas.music);
    } catch (error) {
      console.error(error)
    }
  }

  //视频内容
  if (datas.video) {
    datas.video = JSON.parse(datas.video);
  }

  //产品自定义属性
  if (datas.product.attribute) {
    datas.product.attribute = JSON.parse(datas.product.attribute);
  }

  //企业自定义属性
  if (datas.business.customize_data) {
    datas.business.customize_data = JSON.parse(datas.business.customize_data);
  }

  //工序
  if (!datas.process) {
    datas.process = defaultDatas.process;
  }

  //演示工序
  if (!datas.process_demo) {
    datas.process_demo = defaultDatas.process_demo;
  }

  //经销商
  if (!datas.dealer) {
    datas.dealer = defaultDatas.dealer;
  }

  // document.title = datas.business.name;  //设置页面标题
  return datas;
}

//获取码标信息
export function initDatas(res) {
  const datas = res.meta.product_template; //产品信息
  datas.code = res.meta.code;  //码标
  datas.batch_code = res.meta.batch_code; //溯源码批次
  datas.scan_count = res.meta.scan_count;  //扫码次数
  datas.scan_first_time = res.meta.scan_first_time;  //扫码时间
  datas.scan_first_address = res.meta.scan_first_address;  //扫码地点
  datas.query_count = res.meta.query_count;  //查询次数
  datas.query_first_time = res.meta.query_first_time;  //查询时间
  datas.query_first_address = res.meta.query_first_address;  //查询地点
  datas.source = res.meta.source;
  datas.totalTraceback = 0; //综合溯源率
  
  try {
    //产品OID码
    const rootid = datas.business.rootid;
    const oid = rootid.substring(0, 4); //组织ID
    let pid = `${datas.product.production_id}`;
    pid = Number(pid.substring(pid.length-5));
    datas.c_idcode = datas.business.company_idcode || `1.2.156.47006.${oid}.${rootid}` //企业OID码
    datas.p_idcode = `${datas.c_idcode}.${pid}`; //产品OID码
  } catch (error) { }

  //激活自定义属性
  if (res.meta.activation_a) {
    datas.attribute = JSON.parse(res.meta.activation_a);

    //重定向跳转
    if (datas.attribute.redirect_link) {
      window.location.href = datas.attribute.redirect_link;
    }
  }

  //发货自定义属性
  if (datas.dealer && datas.dealer.length && datas.dealer[0].attribute) {
    datas.attribute = JSON.parse(datas.dealer[0].attribute);
  }

  datas.verify = res.meta.verify; //防伪码

  //焦点图
  if (datas.focus) {
    datas.focus = JSON.parse(datas.focus);
  }

  //自定义栏目
  if (datas.ref) {
    datas.ref = JSON.parse(datas.ref);
  }

  //自定义菜单
  if (datas.menu) {
    datas.menu = JSON.parse(datas.menu);
  }

  //产品自定义属性
  if (datas.product.attribute) {
    datas.product.attribute = JSON.parse(datas.product.attribute);
  }
  if(datas.product.applet_attribute){
    datas.product.applet_attribute = JSON.parse(datas.product.applet_attribute);
  }

  //综合溯源率
  if(datas.product.applet_attribute && datas.product.applet_attribute.traceback){
    let total = 0;
    datas.product.applet_attribute.traceback.forEach(item=>{
      total += Number(item.value);
    })
    total = Math.round(total / datas.product.applet_attribute.traceback.length);
    datas.totalTraceback = total;
  }

  //企业自定义属性
  if (datas.business.customize_data) {
    datas.business.customize_data = JSON.parse(datas.business.customize_data);
  }

  //批次信息
  if (datas.batch) {
    if (datas.batch.qc) {
      datas.batch.qc = JSON.parse(datas.batch.qc);
    }
  }

  //背景音乐
  if (datas.music && datas.music_is_show == 1) {
    try {
      datas.music = JSON.parse(datas.music);
    } catch (error) {
      console.error(error)
    }
  }

  //视频信息
  if (datas.video) {
    datas.video = JSON.parse(datas.video);
  }

  // document.title = datas.business.name;  //设置页面标题
  return datas;
}

//获取用户地址
export function getUserLocation() {
  return new Promise((resolv, reject) => {

    wx.ready(function(){
      wx.getLocation({
        type: 'gcj02',
        success: async (res)=> {
          const latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          const longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180
          const rs = await getAddressByLocation(latitude, longitude);
          resolv({code: 200, msg: '地址获取失败', data: rs});

          //接口已废弃2024.8.2
          // const geocoder = new qq.maps.Geocoder({
          //   complete: function (result) {
          //     resolv({code: 200, msg: '地址获取失败', data: result});
          //   }
          // });
          // const coord = new qq.maps.LatLng(latitude, longitude);
          // geocoder.getAddress(coord);
        }, fail: function (res) {
          resolv({code: 500, msg: res});
        }
      });
    });

    //兼容MAC微信浏览器wx.getLocation无响应
    setTimeout(() => {
      resolv({code: 500, msg: '地址获取失败'});
    }, 10000)

  });
}

//经纬度获取详情地址
function getAddressByLocation(lat, lng){
  return new Promise((resolv, reject)=>{
    $.ajax({
      type: "get",
      url: `${this.GetServerUrl()}/v1/getAddressByLocation?lat=${lat}&lng=${lng}`,
      dataType: 'json',
      success: function(json) {
        if (json.code == "200") {
          resolv(json.meta.result);
        }else{
          resolv(false);
        }
      },
      error: function(e) {
        resolv(false);
        console.log(e)
      }
    })
  })
}



/**
* 格式化日期
* @param {Date|string|number} date - Date对象、时间戳或可解析的日期字符串
* @param {string} format - 格式模板，如 "YYYY-MM-DD HH:mm:ss"
* @returns {string} 格式化后的日期字符串
*/
export function formatDate(date, format = 'YYYY-MM-DD HH:mm:ss') {
 // 如果传入的是时间戳或字符串，转换为Date对象
 const dt = typeof date === 'object' ? date : new Date(date);

 // 检查日期是否有效
 if (isNaN(dt.getTime())) {
   throw new Error('Invalid Date');
 }

 // 定义格式化符号对应的值
 const replacements = {
   'YYYY': dt.getFullYear(),
   'MM': String(dt.getMonth() + 1).padStart(2, '0'), // 月份从0开始
   'DD': String(dt.getDate()).padStart(2, '0'),
   'HH': String(dt.getHours()).padStart(2, '0'),
   'mm': String(dt.getMinutes()).padStart(2, '0'),
   'ss': String(dt.getSeconds()).padStart(2, '0'),
   'SSS': String(dt.getMilliseconds()).padStart(3, '0'),
   'MMMM': ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'][dt.getMonth()],
   'ddd': ['日', '一', '二', '三', '四', '五', '六'][dt.getDay()],
 };

 // 替换格式字符串中的占位符
 let result = format;
 for (const key in replacements) {
   result = result.replace(new RegExp(key, 'g'), replacements[key]);
 }

 return result;
}



// WEBPACK FOOTER //
// ./src/hook/common.js